import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";

import Loading from "./Loaders/Loading";

const FormConfirmationModal = ({
  show,
  title = "Review and confirm details",
  details = [],
  confirmText = "Send Invite",
  confirmationMessage,
  loading = false,
  onClose = () => null,
  onConfirm = () => null,
}) => {
  const profilePhoto = details.find(({ image }) => image)?.image;

  const getDetailValue = (labels) => {
    const detail = details.find(({ label }) =>
      labels.includes(label.toLowerCase())
    );

    return detail?.value;
  };

  const userName =
    getDetailValue(["name", "thriver name", "first name", "full name"]) ||
    "New User";

  const getIcon = (label) => {
    switch (label.toLowerCase()) {
      case "email":
        return "cil-envelope-open";

      case "mobile number":
      case "phone number":
        return "cil-phone";

      case "user type":
      case "role":
      case "name":
      case "thriver name":
        return "cil-user";

      case "country":
      case "location":
        return "cil-location-pin";

      case "relationship":
      case "care circle":
      case "care circles":
        return "cil-people";

      case "gender":
        return "cil-user";

      case "date of birth":
        return "cil-calendar";

      default:
        return "cil-info";
    }
  };
  const getInitials = (name = "") => {
  const words = name.trim().split(/\s+/).filter(Boolean);

  if (!words.length) return "U";

  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  return `${words[0].charAt(0)}${words[words.length - 1].charAt(0)}`.toUpperCase();
};

  return (
    <CModal
      show={show}
      onClose={onClose}
      centered
      size="lg"
      style={{
        color: "#333",
        maxWidth: "720px",
        // maxHeight: "95vh",
        margin: "auto",
      }}
    >
      <CModalHeader closeButton className="py-2 px-4">
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>

      <CModalBody className="px-4 py-2">
        {/* Profile Header */}
        <div className="d-flex align-items-center mb-2">
          <div
            className="d-flex align-items-center justify-content-center mr-3"
            style={{
              width: "80px",
              height: "80px",
              minWidth: "80px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#eef3fa",
            }}
          >
            {profilePhoto ? (
              <img
                src={profilePhoto}
                alt={userName}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
                <div
                  style={{
                    fontSize: "26px",
                    fontWeight: 600,
                    color: "#3674d9",
                    lineHeight: "1",
                  }}
                >
                  {getInitials(userName)}
                </div>
            )}
          </div>

          <div className="flex-grow-1">
            <div
              className="font-weight-bold"
              style={{
                fontSize: "17px",
                lineHeight: "22px",
              }}
            >
              {userName}
            </div>
          </div>
        </div>

        {/* Information Message */}
        <div
          className="d-flex align-items-start mb-2 p-2"
          style={{
            backgroundColor: "#f1f7ff",
            borderRadius: "8px",
            color: "#3d5a80",
          }}
        >
          <CIcon
            name="cil-info"
            className="mr-3 mt-1"
            style={{
              color: "#2f80ed",
              minWidth: "18px",
            }}
          />

          <div>
            <div
              className="font-weight-bold mb-1"
              style={{
                fontSize: "13px",
              }}
            >
              You’re almost there!!
            </div>

            <div
              style={{
                fontSize: "12px",
                lineHeight: "16px",
              }}
            >
              {confirmationMessage ||
                "Please review the details below carefully before sending the invite. The email address and mobile number cannot be changed once the user has been created. If anything is incorrect, please go back and update the details before continuing."}
            </div>
          </div>
        </div>

        {/* Details */}
        <div className="row mx-n2">
          {details
            .filter(({ image }) => !image)
            .map(({ label, value }) => (
              <div
                key={label}
                className="col-6 px-2 mb-2"
              >
                <div className="d-flex align-items-center">
                  {/* Icon */}
                  <div
                    className="d-flex align-items-center justify-content-center mr-2"
                    style={{
                      width: "28px",
                      minWidth: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      backgroundColor: "#f0f5ff",
                      color: "#3674d9",
                    }}
                  >
                    <CIcon name={getIcon(label)} />
                  </div>

                  {/* Label + Value */}
                  <div className="flex-grow-1">
                    <div
                      className="text-muted"
                      style={{
                        fontSize: "11px",
                        lineHeight: "14px",
                      }}
                    >
                      {label}
                    </div>

                    <div
                      className="font-weight-bold text-break"
                      style={{
                        fontSize: "13px",
                        lineHeight: "17px",
                      }}
                    >
                      {value || "Not provided"}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>

        <Loading show={loading} />
      </CModalBody>

      <CModalFooter className="px-4 py-2">
        <CButton
          color="secondary"
          disabled={loading}
          onClick={onClose}
        >
          Go Back
        </CButton>

        <CButton
          color="primary"
          disabled={loading}
          onClick={onConfirm}
        >
          {confirmText}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default FormConfirmationModal;